import React from 'react';
import { connect } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  Text,
  Icon,
  Stack,
  MenuButton,
  Menu,
  MenuList,
  MenuItem,
} from '@chakra-ui/core';
import { Logo } from '../Logo';
import routes from '../../routes';
import Can from '../../../roleBasedAccess/Can';
import { OperatorFilterToggle } from '../OperatorFilterToggle';

const Header = ({ user, onMenuOpen }) => {
  const { pathname } = useLocation();
  const isQuestionSpace =
    pathname === routes.quotes.questions || pathname.startsWith(`${routes.quotes.questions}/`);
  const profileName = [user.firstName, user.lastName].filter(Boolean).join(' ');

  return (
    <Box
      as="header"
      d="flex"
      justifyContent="space-between"
      alignItems="center"
      bg="darkGray"
      color="white"
      py="4"
      px={{ base: 3, md: 5 }}
      boxShadow="layout"
      position="relative"
      zIndex="banner"
    >
      <Flex alignItems="center" minW={0}>
        <Button
          type="button"
          variantColor="neutral"
          display={{ base: 'inline-flex', lg: 'none' }}
          aria-label="Ouvrir le menu principal"
          bg="whiteAlpha.200"
          color="white"
          size="sm"
          rounded="full"
          px={3}
          mr={3}
          onClick={onMenuOpen}
          _hover={{ bg: 'whiteAlpha.300' }}
          _focus={{ boxShadow: 'outlineThin' }}
        >
          Menu
        </Button>
        <NavLink to="/" aria-label="Accueil">
          <Logo alt="" width={{ base: '124px', sm: '150px', md: '176px' }} />
        </NavLink>
      </Flex>

      {!isQuestionSpace && <OperatorFilterToggle />}

      <Menu>
        <Stack
          as={MenuButton}
          isInline
          d="flex"
          alignItems="center"
          spacing={{ base: 0, md: 4 }}
          rounded="lg"
          px={{ base: 1, md: 3 }}
          py={2}
          mr={{ base: 0, md: -3 }}
          aria-label={`Ouvrir le menu du profil${profileName ? ` de ${profileName}` : ''}`}
          transition="background 0.2s"
          css={theme => ({
            '&:focus': { outline: 'none' },
            '&:hover': { backgroundColor: theme.colors.semiDarkGray[900] },
          })}
        >
          <Text display={{ base: 'none', md: 'block' }} fontFamily="heading" fontWeight="600">
            {user.firstName} {user.lastName?.toUpperCase()}
          </Text>
          <Box
            bg="red"
            size="32px"
            p="6px"
            rounded="full"
            d="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Icon name="user" bg="red" />
          </Box>
          <Icon display={{ base: 'none', md: 'block' }} name="chevron-down" strokeWidth="2" />
        </Stack>

        <MenuList
          borderRadius="10px 0px 10px 10px"
          shadow="layout"
          placement="auto-end"
          zIndex="1000"
        >
          <Can
            perform="self:edit"
            yes={() => (
              <UserMenuItem to={routes.profile} transition="none">
                <Icon name="edit" color="coral" mr={2} transition="none" />
                <Text>Editer mon profil</Text>
              </UserMenuItem>
            )}
          />

          <UserMenuItem to={routes.logout} transition="none">
            <Icon name="logout" color="coral" mr={2} transition="none" />
            <Text>Déconnexion</Text>
          </UserMenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};

const UserMenuItem = ({ children, ...props }) => (
  <MenuItem
    as={NavLink}
    color="gray"
    _hover={{ backgroundColor: 'coral.900', color: 'white', svg: { color: 'white' } }}
    {...props}
  >
    {children}
  </MenuItem>
);

const mapStateToProps = ({ authentication: { user } }) => ({ user });

export default connect(mapStateToProps)(Header);
